import { render, staticRenderFns } from "./yunchanxinshen.vue?vue&type=template&id=3fdd5498&scoped=true&"
import script from "./yunchanxinshen.vue?vue&type=script&lang=js&"
export * from "./yunchanxinshen.vue?vue&type=script&lang=js&"
import style0 from "./yunchanxinshen.vue?vue&type=style&index=0&id=3fdd5498&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd5498",
  null
  
)

export default component.exports